import React from 'react'
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from './EmblaCarouselArrowButtons'
import useEmblaCarousel from 'embla-carousel-react'
import Image from 'next/image'
import { useSelector } from 'react-redux'
import enTestimonials from '../../locales/en/testimonials.json'
import esTestimonials from '../../locales/es/testimonials.json'

const EmblaCarousel = (props) => {
  const { slides, options, Ima } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options)
  const Languages = useSelector((state) => state.auth.lang)
  const testimonialContent = Languages === 'es' ? esTestimonials : enTestimonials

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  return (
    <section className="embla" dir="ltl">
   
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {testimonialContent.testimonials.map((testimonial, index) => (
            <div className="embla__slide" key={index}>
              <div className="embla__slide__number">
                <div className='client-image mb-3'>
                  <Image src={Ima} alt="client" width="100" />
                </div>
                <p className='fs-6 font-secondary text-muted mb-4'>{testimonial.content}</p>
                <h5>{testimonial.name}</h5>
                <p className='fs-6 font-secondary text-muted mb-0'>{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="embla__controls primary-color">
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>
    </section>
  )
}

export default EmblaCarousel